// @ts-check

// s_code.js needs to be loaded before this script
// s_account is localized and defined in s_code.js
var cartPage = function(s_account) {
	"use strict";
	var origFocus, itemName, deleteCartItemId, cartId, token,
		cartAccordions = new getAccordions4i(),
		productScroller = new prodScroller(),
		jsMessages = {},
		init = function() {
			jsMessages = JSON.parse(document.getElementById('JsMessages').value);
			// empty cart
			if (document.getElementById("divHotScroller")) {
				productScroller.InitSliderLessItems("divHotScroller");
				// not empty cart
			} else {
				cartId = document.getElementById("UserCart_CartID") ? document.getElementById("UserCart_CartID").value : "";
				token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value : "";

			
				formEvents.CheckCartHasCoupon();
				//formEvents.UpdateBreadCrumb();
				cartAccordions.init(document.getElementById("mainContent"));
				
				const deleteItemDialog = new deleteItemDialog4i();
				deleteItemDialog.Init();
				
				document.getElementById("btnClearCart").addEventListener("click", function(e) {
					e.preventDefault();
					ajaxActions.ClearCart();
				});
				document.getElementById("btnEnterCouponCode") && document.getElementById("btnEnterCouponCode").addEventListener("click", function(e) {
					e.preventDefault();
					formEvents.ShowEnterCouponCode();
				});
				document.getElementById("btnApplyCouponCode").addEventListener("click", function(e) {
					e.preventDefault();
					formEvents.SubmitCouponCode();
				});
				document.getElementById("btnCancelCouponCode").addEventListener("click", function(e) {
					e.preventDefault();
					formEvents.HideEnterCouponCode();
				});
				document.getElementById("removeCouponCode") && document.getElementById("removeCouponCode").addEventListener("click", function(e) {
					e.preventDefault();
					ajaxActions.DeleteCouponCode(this);
				});
				if (document.getElementById("btnCheckOut_mini")) {
					document.getElementById("btnCheckOut_mini").addEventListener("click", function(e) {
						formEvents.ShowBusy();
					});
				}
				if(document.querySelector(".cartDetailsBtn")){
					const detailsDialog = new detailsDialog4i();
					detailsDialog.Init();
				}
				document.getElementById("btnCheckOut_large").addEventListener("click", function(e) {
					formEvents.ShowBusy();
				});
			}

			if (!!window.performance && window.performance.navigation.type === 2) {
				// page has been hit using back or forward buttons
				document.getElementById("bodyPanel").style.display = "none";
				window.location.reload();
			}
		},
		
		detailsDialog4i = function(){
			let detailsDialog,
			init = function(){
				detailsDialog = new Dialog4i();
				const triggers = [].slice.call(document.getElementById('divCartTable').querySelectorAll('.cartDetailsBtn'));
				const loadingContent = '<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading item details dialog, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
				detailsDialog.Init({
					triggerElements: triggers,
					dialogClass: "divItemDetails",
					title: "Loading Item Details", 
					content: loadingContent, 
					onOpen: open
				});
			},
			open = function(element) {
				getDialogContent(element);
			},
			getDialogContent = function(line) {
				fetch('/cart/itemdetails', { 
					method: 'POST', 
					body: JSON.stringify({ cartId: cartId, cartItemId: line.getAttribute("data-cart-item-id") }), 
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": token }
				}).then(function(response){
					return  (response.ok) ? response.text() : []; // response.json() returns a promise
				}).then(function(response){
					let prodName = line.parentNode.parentNode.querySelector(".productInfo").textContent;
					document.getElementById("popUpDialog").querySelector("h2").textContent = prodName;
					document.getElementById("popUpDialog").querySelector(".dialogContent").innerHTML = response;
					formEvents.HideAjaxMessage();
				}).catch(function(error){
					detailsDialog.Close();
					formEvents.ShowAjaxMessage(jsMessages.getItemDetailsError);
				});
			};
			return{
				Init: init
			};
		},
		deleteItemDialog4i = function(){
			let deleteDialog,
			init = function(){
				deleteDialog = new Dialog4i();
				const triggers = [].slice.call(document.querySelectorAll(".cartDeleteBtn"));
				const dialogContent = 
					'<div class="displayFlex flexJustifyEnd flexAlignItemsCenter">' +
						'<button class="close4iDialog btnToHyp underline text16">Cancel</button>' +
						'<button id="btnConfirmDelete" class="button-md bkgdBlue whiteLink text16">Delete</button>' +
					'</div>';
				deleteDialog.Init({
					triggerElements: triggers,
					dialogClass: "confirmDelete", 
					title: "Delete Product?", 
					content: dialogContent, 
					onOpen: open,
					onClose: close
				});
			},
			open = function(el){
				itemName = el.parentNode.parentNode.querySelector(".productInfo").getAttribute("data-description");
				document.getElementById("popUpDialog").querySelector('h2').innerHTML = "Delete " + itemName + "?";
				formEvents.GetCartItemID(el);
				
				document.getElementById("btnConfirmDelete").addEventListener("click", function(e) {
					e.preventDefault();
					deleteItem(deleteCartItemId);
				});
			}, 
			deleteItem = function(cartItemId) {
				formEvents.ShowBusy();
				formEvents.RemoveCartItemID();
				deleteDialog.Close();
				//deleteCartItemDialog.close(); //TODO
        			
				fetch('/cart/deleteitem', { 
					method: 'POST', 
					body: JSON.stringify({ cartId: cartId, cartItemId: cartItemId }), 
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": token, "RequestVerificationToken": token },
					credentials: 'same-origin'
				}).then(function(response){
					return  (response.ok) ? response.json() : []; // response.json() returns a promise
				}).then(function(response){
					if (response.Success) {
						omniture.RemoveItem(formEvents.RemoveItem(cartItemId, response));
						formEvents.HideAjaxMessage();
						if (document.getElementById("itemRemovalAlert")) {
							document.getElementById("itemRemovalAlert").parentNode.removeChild(document.getElementById("itemRemovalAlert"));
						}
						//notify screen readers that item has been deleted
						document.querySelector("h1").insertAdjacentHTML("afterend", '<div id="itemRemovalAlert" class="visually-hidden" role="alert" aria-atomic="true"></div>');
						document.getElementById("itemRemovalAlert").textContent = itemName + " removed from your cart.";
						document.getElementById("cartLinks").getElementsByTagName("a")[0].focus();
						formEvents.HideBusy();
					} else {
						formEvents.ShowAjaxMessage(jsMessages.deleteFailed);
						formEvents.HideBusy();
					}
				}).catch(function(error){
					formEvents.ShowAjaxMessage(jsMessages.deleteFailed);
					formEvents.HideBusy();
				});
			},
			close = function(){
				formEvents.RemoveCartItemID();
			};
			return{
				Init: init
			};
		},
		
		formEvents = (function() {
			var showBusy = function() {
					document.getElementsByClassName("loading")[0].classList.remove("hide");
				},
				hideBusy = function() {
					document.getElementsByClassName("loading")[0].classList.add("hide");
				},
				showEnterCouponCode = function() {
					document.getElementById("btnEnterCouponCode").setAttribute("aria-expanded", "true");
					document.getElementById("btnEnterCouponCode").classList.add("hide");
					document.getElementById("divCouponCode").classList.remove("hide");
					document.getElementById("txtCouponCode").focus();
				},
				submitCouponCode = function() {
					var couponCode = document.getElementById("txtCouponCode").value.toUpperCase();

					if (couponCode) {
						ajaxActions.AddCouponCode(couponCode);
					} else {
						couponCodeError("Oops! The coupon code is not valid. Please Try Again.");
					}
				},
				couponCodeError = function(errMsg) {
					document.getElementById("couponCodeError").classList.remove("hide");
					document.getElementById("couponCodeError").textContent = errMsg;
					document.getElementById("txtCouponCode").classList.add("input-validation-error");
					document.getElementById("txtCouponCode").setAttribute("aria-invalid", "true");
					document.getElementById("txtCouponCode").focus();
				},
				hideEnterCouponCode = function() {
					document.getElementById("btnEnterCouponCode").setAttribute("aria-expanded", "false");
					document.getElementById("btnEnterCouponCode").classList.remove("hide");
					document.getElementById("btnEnterCouponCode").focus();
					document.getElementById("divCouponCode").classList.add("hide");
					document.getElementById("couponCodeError").classList.add("hide");
					document.getElementById("txtCouponCode").classList.remove("input-validation-error");
					document.getElementById("txtCouponCode").removeAttribute("aria-invalid");
					document.getElementById("txtCouponCode").value = "";
				},
				addCouponCode = function(data, code) {
					if (!data.ItemCount) {
						reloadPage();
					} else {
						hideEnterCouponCode();
						document.getElementById("cartSub").textContent = "";
						document.getElementById("removeCouponCode").setAttribute("title", document.getElementById("removeCouponCode").getAttribute("title") + code);
						document.getElementById("removeCouponCode").setAttribute("data-coupon-code", code);
						document.getElementById("couponApplied").innerHTML = code + document.getElementById("couponApplied").innerHTML;
						var cartItemCounts = document.querySelectorAll(".cartItemCount");
						for (var i = 0; i < cartItemCounts.length; i++) {
							cartItemCounts[i].innerHTML = data.ItemCount;
						}
						document.getElementById("cartSub").innerHTML = data.SubTotal;
						document.getElementById("couponDiscountAmount").innerHTML = data.CouponTotal;
						document.getElementById("divShowCouponCodes").classList.remove("hide");
						document.getElementById("removeCouponCode").focus();
						//document.getElementById("orderSummaryBox").getElementsByClassName("btnCheckOut")[0].focus();
						checkCartHasCoupon();
						updateHeaderCartSummary(data);
					}
				},
				deleteCouponCode = function(data, code) {
					if (!data.ItemCount) {
						reloadPage();
					} else {
						document.getElementById("cartSub").textContent = "";
						document.getElementById("divShowCouponCodes").classList.add("hide");
						document.getElementById("removeCouponCode").setAttribute("title", document.getElementById("removeCouponCode").getAttribute("title").replace(code, ""));
						document.getElementById("removeCouponCode").setAttribute("data-coupon-code", "");
						document.getElementById("couponApplied").innerHTML = document.getElementById("couponApplied").innerHTML.replace(code, "");
						var cartItemCounts = document.querySelectorAll(".cartItemCount");
						for (var i = 0; i < cartItemCounts.length; i++) {
							cartItemCounts[i].innerHTML = data.ItemCount;
						}
						document.getElementById("cartSub").innerHTML = data.SubTotal;
						document.getElementById("couponDiscountAmount").innerHTML = data.CouponTotal;
						document.getElementById("orderSummaryBox").getElementsByClassName("btnCheckOut")[0].focus();
						checkCartHasCoupon();
						updateHeaderCartSummary(data);
					}
				},
				updateItemNotifications = function(data) {
					document.getElementById("divItemNotifications").innerHTML = data.PartialView2;
				},
				reloadPage = function() {
					location.reload(true);
				},
				checkCartHasCoupon = function() {
					if (document.getElementById("divShowCouponCodes").classList.contains("hide")) {
						document.getElementById("btnEnterCouponCode") && document.getElementById("btnEnterCouponCode").classList.remove("hide");
					} else {
						document.getElementById("btnEnterCouponCode") && document.getElementById("btnEnterCouponCode").classList.add("hide");
					}
				},
				getCartItemID = function(line) {
					deleteCartItemId = line.getAttribute("data-cart-item-id");
				},
				removeCartItemID = function() {
					deleteCartItemId = undefined;
				},
				removeItem = function(cartItemId, data) {
					var element = document.getElementById("h3ProductInfo_" + cartItemId);

					if (!data.ItemCount) {
						gtm.LogCartRemoval(element, reloadPage);
					} else {
						var product = ";" + element.getAttribute("data-catalog") + " " + element.getAttribute("data-description").replace("\"", "") + ";" + element.getAttribute("data-quantity") + ";" + element.getAttribute("data-price");

						document.getElementById("divCartItem_" + cartItemId).parentNode.removeChild(document.getElementById("divCartItem_" + cartItemId));
						var cartItemCounts = document.querySelectorAll(".cartItemCount");
						for (var i = 0; i < cartItemCounts.length; i++) {
							cartItemCounts[i].innerHTML = data.ItemCount;
						}
						var cartsub = document.getElementsByClassName("cartSubtotal");

						for (var x = 0; x < cartsub.length; x++) {
							cartsub[x].innerHTML = data.SubTotal;
						}

						document.getElementById("couponDiscountAmount").innerHTML = data.CouponTotal;
						updateHeaderCartSummary(data);
						updateItemNotifications(data);
						checkCouponRemoved(data);
						hideBusy();

						gtm.LogCartRemoval(element);

						return product;
					}
				},
				checkCouponRemoved = function(data) {
					var code = document.getElementById("removeCouponCode").getAttribute("data-coupon-code");

					// remove dollar and cents symbol
					if (code && parseFloat(data.CouponTotal.replace(/(&#[0-9]+;)|(&[A-Za-z0-9]+;)|,/g, "")) === 0) {
						deleteCouponCode(data, code);
					}
				},
				updateHeaderCartSummary = function(data) {
					if (data.PartialView1) {
						document.getElementById("userSpecificLinksBox").querySelectorAll(".cartSummaryContainer")[0].innerHTML = data.PartialView1;
						var headerLinks = new header4i();
						//headerLinks.init_cartsummary();
						headerLinks.HeaderCart.Init();
					}
				},
				/*updateBreadCrumb = function () {
					var url = document.getElementById("orderSummaryBox").getElementsByClassName("btnCheckOut")[0].getAttribute("href");
					var parent = document.getElementById("divShipPymtBC").parentNode;
		
					if (parent.tagName !== "a") {
						parent.innerHTML = "<a href='" + url + "' class='show noLine'>" + parent.innerHTML + "</a>";
					}
				},*/
				updateHotScroller = function(data) {
					document.getElementById("divHotScroller").innerHTML = data;
				},
				showAjaxMessage = function(msg) {
					document.getElementById("divNotification").innerHTML = msg;
					document.getElementById("divNotification").classList.remove("hide");
					document.getElementById("divNotification").focus();
				},
				hideAjaxMessage = function() {
					document.getElementById("divNotification").classList.add("hide");
				};

			return {
				GetCartItemID: getCartItemID,
				RemoveCartItemID: removeCartItemID,
				ShowEnterCouponCode: showEnterCouponCode,
				HideEnterCouponCode: hideEnterCouponCode,
				SubmitCouponCode: submitCouponCode,
				CouponCodeError: couponCodeError,
				AddCouponCode: addCouponCode,
				DeleteCouponCode: deleteCouponCode,
				RemoveItem: removeItem,
				ShowAjaxMessage: showAjaxMessage,
				HideAjaxMessage: hideAjaxMessage,
				ShowBusy: showBusy,
				HideBusy: hideBusy,
				ReloadPage: reloadPage,
				UpdateHotScroller: updateHotScroller,
				//UpdateBreadCrumb: updateBreadCrumb,
				CheckCartHasCoupon: checkCartHasCoupon
			};
		}()),
		ajaxActions = (function() {
			var antiForgeryToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? { "__RequestVerificationToken": document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value } : "",
				/*jsMessages = "",
				
				getMessages = function() {
					fetch('/cart/javascriptMessages/cart', { 
						method: 'GET', 
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
					}).then(function(response){
						return  (response.ok) ? response.json() : []; // response.json() returns a promise
					}).then(function(response){
						jsMessages = response;
					}).catch(function(error){
						return null;
					});
				},*/
				addCouponCode = function(code) {
					formEvents.ShowBusy();
						        			
					fetch('/cart/addcoupon', { 
						method: 'POST', 
						body: JSON.stringify({ cartId: cartId, couponCode: code }), 
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": token }
					}).then(function(response){
						return  (response.ok) ? response.json() : []; // response.json() returns a promise
					}).then(function(response){
						if (response.Success) {
							formEvents.AddCouponCode(response, code);
							omniture.AddCouponCode(code);
							formEvents.HideBusy();
						} else {
							formEvents.CouponCodeError(response.Message);
							formEvents.HideBusy();
						}
					}).catch(function(error){
						formEvents.CouponCodeError(jsMessages.couponError);
						formEvents.HideBusy();
					});
				},
				deleteCouponCode = function(coupon) {
					formEvents.ShowBusy();
					var code = coupon.getAttribute("data-coupon-code");
						        			
					fetch('/cart/deletecoupon', { 
						method: 'POST', 
						body: JSON.stringify({ cartId: cartId, couponCode: code }), 
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": token }
					}).then(function(response){
						return  (response.ok) ? response.json() : []; // response.json() returns a promise
					}).then(function(response){
						if (response.Success) {
							formEvents.DeleteCouponCode(response, code);
							formEvents.HideAjaxMessage();
							formEvents.HideBusy();
						} else {
							formEvents.ShowAjaxMessage(response.Message);
							formEvents.HideBusy();
						}
					}).catch(function(error){
						formEvents.ShowAjaxMessage(jsMessages.deleteCouponError);
						formEvents.HideBusy();
					});
				},
				clearCart = function() {
					formEvents.ShowBusy();
						        			
					fetch('/cart/clearCart', { 
						method: 'POST', 
						body: JSON.stringify({ cartId: cartId }), 
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": token }
					}).then(function(response){
						return  (response.ok) ? response.json() : []; // response.json() returns a promise
					}).then(function(response){
						if (response.Success) {
							var isMessage = response.Message ? true : "";
							if (isMessage !== "") {
								omniture.RemoveItem(response.Message);

								var rows = Array.prototype.slice.call(document.querySelectorAll('#divCartTable .cartItems'));
								for (var i = 0; i < rows.length; i++) {
									var id = rows[i].id.split('_');
									gtm.LogCartRemoval(document.getElementById("h3ProductInfo_" + id[1]), i + 1 === rows.length ? formEvents.ReloadPage : undefined);
								}
							} else {
								formEvents.ReloadPage();
							}
						} else {
							formEvents.ShowAjaxMessage(response.Message);
							formEvents.HideBusy();
						}
					}).catch(function(error){
						formEvents.ShowAjaxMessage(jsMessages.clearCartError);
						formEvents.HideBusy();
					});
				},
				getHotItems = function() {
					fetch('/productscroller/hotitems', {
						method: 'GET'
					}).then(function(response) {
						return (response.ok) ? response.text() : []; // response.text() returns a promise
					}).then(function(response) {
						formEvents.UpdateHotScroller(response);
					});
				};

			//getMessages(); // ajax call to get error messages

			return {
				AddCouponCode: addCouponCode,
				DeleteCouponCode: deleteCouponCode,
				ClearCart: clearCart,
				GetHotItems: getHotItems
			};
		}()),

		gtm = (function() {
			const logCartRemoval = function(product, callBack) {
				if (typeof dataLayer !== 'undefined' && !!window.ga && product) {
					var products = [];

					products.push(getProductObject(product));

					// Measure the removal of a product from a shopping cart.
					dataLayer.push({
						'event': 'removeFromCart',
						'ecommerce': {
							'remove': {
								'products': products
							}
						},
						'eventCallback': function() {
							if (callBack) {
								callBack();
							}
						}
					});
				} else {
					if (callBack) {
						callBack();
					}
				}
			}

			const getProductObject = function(product) {
				return {
					'name': product.getAttribute('data-description').replace("'", ''),
					'id': product.getAttribute("data-catalog"),
					'price': product.getAttribute("data-unit-price"),
					'brand': product.getAttribute('data-brand'),
					'category': product.getAttribute('data-category'),
					'variant': product.getAttribute('data-color'),
					'quantity': product.getAttribute("data-quantity")

				};
			}

			return {
				LogCartRemoval: logCartRemoval
			}
		}()),

		omniture = (function(s_account) {
			var account = s_account ? s_account : "4imprintprod",
				addCouponCode = function(couponCode) {
					var s = s_gi(account);
					s.linkTrackVars = 'eVar5,events';
					s.linkTrackEvents = 'event2';
					s.eVar5 = couponCode;
					s.events = 'event2';
					s.tl(true, 'o', 'Coupon Codes');
				},
				removeItem = function(product) {
					var s = s_gi(account);
					s.linkTrackVars = 'products,events';
					s.linkTrackEvents = 'scRemove';
					s.events = 'scRemove';
					s.products = product;
					s.tl(true, 'o', 'Cart Delete Item');
				};

			return {
				AddCouponCode: addCouponCode,
				RemoveItem: removeItem
			};
		}(s_account));

	return {
		init: init
		//CartAccordions: cartAccordions
	};
};

(function() {
	var cart = new cartPage(s_account);
	cart.init();
})()